<template>
  <div>
    <div class="row bg-cat" :style="'margin: 0; color:#fff; min-height:100vh; padding: 30px 0 50px 0;'">
      <div class="container bgw">
        <div class="row">
          <div class="col-md-12">
            <h1 class="text-center">Оформление заказа</h1>
            <hr>
            <p class="text-center" v-if="state.cart.length == 0">Вы еще ничего не выбрали.</p>
          </div>



          <div v-if="state.cart.length > 0">

           <cartInOrder></cartInOrder>
            <hr>
            <orderForm ></orderForm>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cart from './cart'
import form from './form'

  export default {
    components: {
      'cartInOrder': cart,
      'orderForm': form,
    },
    computed: {
      config() {
        return this.$store.state.config;
      },
      state() {
        return this.$store.state;
      },
    },
    methods: {
      bg() {
        var vm = this;
        return vm.state.config.url + vm.state.config.img_url + vm.state.config.id + '/' + vm.state.info.background;
      }
    }
  }

</script>

<style>
  .form-control {
    height: calc(2.25rem + 8px);
  }

  .col-form-label {
    font-size: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Order/order.vue